// extracted by mini-css-extract-plugin
export var container = "ServicesItem-module--container--1Dg_y";
export var reverse = "ServicesItem-module--reverse--3X-lb";
export var container__item = "ServicesItem-module--container__item--3cRZw";
export var column = "ServicesItem-module--column--23Lvz";
export var container__item__image = "ServicesItem-module--container__item__image--1DIQC";
export var linkWrap = "ServicesItem-module--linkWrap--aZjT0";